const supportsLocalStorage = (): boolean => {
  try {
    return !!window.localStorage;
  } catch (e) {
    return false;
  }
};

export const getItem = (name: string): string | number | null => {
  if (!supportsLocalStorage()) {
    return null;
  }

  try {
    const value = window.localStorage.getItem(name);
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const saveItem = (name: string, value: any): string | boolean => {
  if (!supportsLocalStorage()) {
    return false;
  }

  const toSave = typeof value !== 'string' ? JSON.stringify(value) : value;

  try {
    window.localStorage.setItem(name, toSave);
    return true;
  } catch (e) {
    return false;
  }
};

export const removeItem = (name: string): string | boolean => {
  if (!supportsLocalStorage()) {
    return false;
  }

  try {
    window.localStorage.removeItem(name);
    return true;
  } catch (e) {
    return false;
  }
};
